"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { ExternalLink, User } from "lucide-react";
import { useLanguage } from "~/translations/loader/use-language";
export default function HeaderMainHungary() {
  const $ = _c(18);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ExternalLink className="ml-2" size={16} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.hungary_nav_link_career) {
    t1 = <CustomLink blank={true} className="mt-3 -ml-4 flex h-10 items-center rounded-lg bg-primary px-4 font-bold text-white transition-colors duration-150 hover:bg-primaryDark" href="https://www.eon.hu/hu/rolunk/karrier.html">{t.hungary_nav_link_career}{t0}</CustomLink>;
    $[1] = t.hungary_nav_link_career;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-8 w-8 lg:hidden"><User className="text-primary" size={32} /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.header_login_text) {
    t3 = <p className="hidden text-center leading-5 hover:underline lg:block">{t.header_login_text}</p>;
    $[4] = t.header_login_text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t.header_login_link || $[7] !== t3) {
    t4 = <CustomLink blank={true} href={t.header_login_link}>{t2}{t3}</CustomLink>;
    $[6] = t.header_login_link;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CustomImage alt="E.ON Logo" height={28} src="images/logo/logo_color.svg" width={96} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t.header_home) {
    t6 = <CustomLink aria-label={t.header_home} className="-mb-1" href="/" prefetch={false} title={t.header_home}>{t5}</CustomLink>;
    $[10] = t.header_home;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="absolute top-0 right-6 flex h-full items-center justify-center gap-5 md:right-10 md:items-center lg:static">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <header className="sticky top-0 z-50 h-16 w-full bg-white text-clientFont text-lg print:hidden"><div className="relative w-full border-gray-200 border-b-4 px-6 md:px-10"><div className="mx-auto flex h-16 max-w-screen-xl justify-between text-center">{t1}{t7}</div></div></header>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}